/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamCompanyDropdown200,
  GetApiV1ExamCompanyDropdown400,
  GetApiV1ExamCompanyDropdown401,
  GetApiV1ExamCompanyDropdown500,
  GetApiV1ExamCompanyDropdownQueryParams,
  GetApiV1ExamCompanyDropdownQueryResponse,
} from "../../types/examSharedController/GetApiV1ExamCompanyDropdown.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

export const getApiV1ExamCompanyDropdownQueryParamsSchema = z
  .object({
    courseId: z.optional(z.coerce.number().int()),
    companyId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1ExamCompanyDropdownQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamCompanyDropdown200Schema = z.array(
  z.lazy(() => dropDownRepositoryResponseSchema),
) as unknown as ToZod<GetApiV1ExamCompanyDropdown200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1ExamCompanyDropdown400Schema =
  z.any() as unknown as ToZod<GetApiV1ExamCompanyDropdown400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamCompanyDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamCompanyDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamCompanyDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamCompanyDropdown500>;

export const getApiV1ExamCompanyDropdownQueryResponseSchema = z.lazy(
  () => getApiV1ExamCompanyDropdown200Schema,
) as unknown as ToZod<GetApiV1ExamCompanyDropdownQueryResponse>;
